import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete } from 'antd';
import debounce from 'lodash.debounce';

import { searchUsers } from 'modules/users';

export class SearchUser extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func,
    onSearch: PropTypes.func,
    inGroups: PropTypes.arrayOf(PropTypes.string),
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    onSelect () {},
    onSearch () {},
    inGroups: [],
    placeholder: 'Email de l\'utilisateur',
  };

  state = {
    dataSource: [],
  };

  search = async search => { // eslint-disable-line react/sort-comp
    const { inGroups } = this.props;
    const results = await searchUsers({
      search,
      inGroups,
    });
    this.users = results;
    const dataSource = results.map(user => ({
      value: user.id,
      text: user.email,
    }));
    this.setState({ dataSource });
  }

  debouncedSearch = debounce(this.search, 1000);

  onSearch = search => {
    this.props.onSearch(search);
    this.debouncedSearch(search);
  }

  onSelect = id => {
    const { onSelect } = this.props;
    onSelect(this.users.find(user => user.id === +id));
  }

  render () {
    const { placeholder } = this.props;
    const { dataSource } = this.state;
    const { onSearch, onSelect } = this;

    return (
      <AutoComplete
        dataSource={dataSource}
        onSelect={onSelect}
        onSearch={onSearch}
        placeholder={placeholder}
      />
    );
  }
}

export default SearchUser;



// WEBPACK FOOTER //
// ./src/components/Admin/UsersManagement/SearchUser/index.js